/** @param {antring} s @returns {string}  */
export function normalize(s) {
    let n = s.replaceAll(" ", "");
    n = n.toLowerCase();
    n = n.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    n = n.replace(/[&#"'|_^\(\)\[\]\\\/+*@={}~`°]/g, "");
    return n
}

/**
@param {Object.<string, string>} namelist 
@param {string[]} groups 
@returns {string}
*/
export function displayNames(namelist, groups) {
    const getGroupStr = g => g == "public" ? "Publique" : namelist[g] || "???"
    return groups.map(g => getGroupStr(g)).join(", ");
}

export function displayComments(comments) {
    let num = comments;
    if (comments instanceof Array) num = comments.length;
    return num ? `(${num})` : "";
}

/** @param {number} t @returns {string} */
export const timestamp2date = t => new Date(t * 1000).toLocaleDateString("fr-FR");

/** @param {string[]} g1 @param {string[]} g2 @returns {boolean}  */
export const shareGroups = (g1, g2) => !! g1.filter(g => g2.includes(g));

